import { createSlice } from '@reduxjs/toolkit';

function loadMarket() {
  try {
    const raw = localStorage.getItem('market');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const configSlice = createSlice({
  name: 'config',
  initialState: {
    open: false,
    regressionModalOpen: false,
    market: loadMarket(),
    regressionTestId: null,
    userEmail: 'placeholder@gmail.com',
  },
  reducers: {
    updateConfigOpen: (state, action) => {
      state.open = action.payload;
    },
    updateMarket: (state, action) => {
      state.market = { ...action.payload };
      localStorage.setItem('market', JSON.stringify(action.payload));
    },
    updateRegressionTestId: (state, action) => {
      state.regressionTestId = action.payload;
    },
    updateUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    updateRegressionModalOpen: (state, action) => {
      state.regressionModalOpen = action.payload;
    },
  },
});

export const {
  updateConfigOpen,
  updateMarket,
  updateRegressionTestId,
  updateUserEmail,
  updateRegressionModalOpen,
} = configSlice.actions;
export const selectConfigOpen = (state) => state.config.open;
export const selectMarket = (state) => state.config.market;
export const selectRegressionTestId = (state) => state.config.regressionTestId;
export const selectUserEmail = (state) => state.config.userEmail;
export const selectRegressionModalOpen = (state) => state.config.regressionModalOpen;
export default configSlice.reducer;
